export enum Timelevel {
    Application,
    Project,
    Task,
}
